import { Injectable, inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';

@Injectable({
  providedIn: 'root'
})
export class ThemeService {
  private readonly document = inject(DOCUMENT);

  constructor() {
    // Always apply dark theme
    this.applyDarkTheme();
  }

  private applyDarkTheme(): void {
    const htmlElement = this.document.documentElement;
    
    // Apply dark theme class and attribute
    htmlElement.classList.add('dark-mode');
    htmlElement.setAttribute('data-theme', 'dark');
    
    // Apply dark theme CSS variables
    htmlElement.style.setProperty('--p-surface-0', '#141222');
    htmlElement.style.setProperty('--p-surface-50', '#2c2c2c');
    htmlElement.style.setProperty('--p-surface-100', '#3a3a3a');
    htmlElement.style.setProperty('--p-surface-200', '#484848');
    htmlElement.style.setProperty('--p-surface-300', '#565656');
    htmlElement.style.setProperty('--p-surface-600', '#868e96');
    htmlElement.style.setProperty('--p-surface-700', '#6c757d');
    htmlElement.style.setProperty('--p-surface-800', '#495057');
    htmlElement.style.setProperty('--p-surface-900', '#343a40');
    htmlElement.style.setProperty('--p-text-color', '#ffffff');
    htmlElement.style.setProperty('--p-text-muted-color', '#adb5bd');
    htmlElement.style.setProperty('--p-text-hover-color', '#dee2e6');
    htmlElement.style.setProperty('--p-surface-border', '#495057');
    htmlElement.style.setProperty('--p-primary-color', '#9000ff');
    htmlElement.style.setProperty('--p-primary-contrast-color', '#ffffff');
    htmlElement.style.setProperty('--p-focus-ring-color', '#9000ff');
  }
}

